export var CfFilterComponentsType;
(function (CfFilterComponentsType) {
    CfFilterComponentsType["dropdown"] = "dropdown";
    CfFilterComponentsType["checkboxes"] = "checkboxes";
    CfFilterComponentsType["range_slider"] = "range slider";
})(CfFilterComponentsType || (CfFilterComponentsType = {}));
/** CourseFinderCourseCardDto */
//# sourceMappingURL=geebeeCfTypes.js.map